import { useState, useEffect } from "react";
import Header from "../layout/header";
import MaterialTable from "material-table";
import { ArrowDownward } from "@material-ui/icons";
import Search from "@material-ui/icons/Search";
import ViewColumn from "@material-ui/icons/ViewColumn";
import SaveAlt from "@material-ui/icons/SaveAlt";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import FirstPage from "@material-ui/icons/FirstPage";
import LastPage from "@material-ui/icons/LastPage";
import Add from "@material-ui/icons/Add";
import Check from "@material-ui/icons/Check";
import FilterList from "@material-ui/icons/FilterList";
import Remove from "@material-ui/icons/Remove";
import Clear from "@material-ui/icons/Clear";
import Edit from "@material-ui/icons/Edit";
import { Loader } from "react-overlay-loader";
import { axiosInstance } from "../config/https";
import { toast } from "react-toastify";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { useNavigate } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";
import { IoMdClose } from "react-icons/io";

export default function User() {
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState([]);
  const [errors, setErrors] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  
  const [, setMessage] = useState([]);
  const [email, setEmail] = useState('');
  const [cellNo, setCellNo] = useState('');
  const [addres, setAddres] = useState('');
  const [fName, setFName] = useState('');
  const [lName, setLName] = useState('');


  const handleContactus = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('first_name', fName);
    formData.append('last_name', lName);
    formData.append('email', email);
    formData.append('phone', cellNo);
    formData.append('address', addres);

    try {
      const response = await axiosInstance.post('/add/user', formData);

      console.log(response, 'Success');
      if (response.data.status === true) {
        toast.success('Details submit successful');
        setMessage(response?.data?.message);
        setLName('');
        setFName('');
        setEmail('');
        setCellNo('');
        setAddres('');
        setErrors({});
        setShowModal(false);
      } else {
        const apiErrors = response?.data?.data;
        if (apiErrors) {
          setErrors(apiErrors);
        } else {
        toast.error('Form Submission Failed');
      }
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };

  useEffect(() => {
    GetUser();
  }, []);

  const handleClose = () => setShowModal(false); 

  // GET users
  const GetUser = () => {
    setLoader(true);
    axiosInstance.get("/All/users").then((response) => {
      setLoader(false);
      console.log("res", response);

      if (response?.data?.status) {
        setData(response.data.data);
      } else {
        toast.warning(response?.data?.message);
      }
    });
  };

  const [, setDltData] = useState();
  const handleDelete = (rowData) => {
    
    setLoader(true);
    axiosInstance.post(`/del/user/${rowData.id}`).then((response) => {
      setLoader(false);
      console.log("res", response);

      if (response?.data?.status) {
        setDltData(response.data.data);
        GetUser();
      } else {
        toast.warning(response?.data?.message);
      }
    });
  };

  return (
    <div>
      {loader === true ? <Loader fullPage loading /> : null}

      <Header />
      <div className="app-content content">
        <div className="content-wrapper">
          <div className="content-header row">
            <div className="content-header-left col-md-6 col-12 mb-2 breadcrumb-new">
              <h3 className="content-header-title mb-0 d-inline-block">
                Users
              </h3>
            </div>
            <div class="content-header-right col-md-6 col-12">
            <div class="dropdown float-md-right">
                <button
                style={{backgroundColor: "#1E9FF2"}}
                class="btn btn round btn-glow px-2"
                type="button"
                onClick={() => setShowModal(true)}
              >
                Add User
              </button>
            </div>
            </div>
          </div>

          <div className="content-body">
            <MaterialTable
              title=""
              icons={{
                Check: Check,
                DetailPanel: ChevronRight,
                // Delete: DeleteOutline,
                Export: SaveAlt,
                Filter: FilterList,
                FirstPage: FirstPage,
                LastPage: LastPage,
                NextPage: ChevronRight,
                PreviousPage: ChevronLeft,
                Search: Search,
                ThirdStateCheck: Remove,
                Add: Add,
                SortArrow: ArrowDownward,
                Clear: Clear,
                Edit: Edit,
                ViewColumn: ViewColumn,
                ResetSearch: Clear,
              }}
              columns={[
                { title: "First Name", field: "first_name" },
                { title: "Last Name", field: "last_name" },
                { title: "Email", field: "email" },
                { title: "Phone", field: "phone" },
                { title: "Action",
                    render: (rowData) => (
                      <>
                         <EditIcon onClick={() =>  navigate("/editUser/" + rowData.id)} />
                         <DeleteIcon onClick={() => handleDelete(rowData)} />
                      </>
                    ),
                  },
                ]}
              data={data}
              options={{
                actionsColumnIndex: -1,
                exportButton: true,
                headerStyle: {
                  backgroundColor: "#1E9FF2 ",
                  color: "#FFF",
                },
                cellStyle: {
                  // backgroundColor: '#191919',
                  // color: '#fff',
                },
              }}
            />
          </div>
        </div>
      </div>
      <Modal show={showModal} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title>Add User</Modal.Title>
          <IoMdClose size={24} className="close-icon" onClick={handleClose} /> {/* Close icon */}
        </Modal.Header>
        <Modal.Body>
        <form id="userForm"  onSubmit={handleContactus}>
          <div class="form-group">
            <label for="firstName">First Name</label>
            <input
            className="form-control"
            type="text"
            name="name"
            value={fName}
            onChange={(e) => setFName(e.target.value)}
            required />
            {errors && <span className="error">{errors.first_name}</span>}
          </div>
          <div class="form-group">
            <label for="lastName">Last Name</label>
            <input
             className="form-control"
             type="text"
             name="name"
             value={lName}
             onChange={(e) => setLName(e.target.value)}
             required />
             {errors && <span className="error">{errors.last_name}</span>}
          </div>
          <div class="form-group">
            <label for="email">Email</label>
            <input
            className="form-control"
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required />
            {errors && <span className="error">{errors.email}</span>}
          </div>
          <div class="form-group">
            <label for="phone">Phone</label>
            <input
            className="form-control"
            type="text"
            name="phone"
            value={cellNo}
            onChange={(e) => setCellNo(e.target.value)}
            required />
            {errors && errors.phone && <span className="error">{errors.phone[0]}</span>}
          </div>
          <div class="form-group">
            <label for="address">Address</label>
            <input
            className="form-control"
            type="text"
            name="address"
            value={addres}
            onChange={(e) => setAddres(e.target.value)}
            required />
            {errors && <span className="error">{errors.address}</span>}
          </div>
          <button type="submit" class="btn btn" style={{backgroundColor: "#1E9FF2"}}>Submit</button>
        </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
